// @flow
import React from 'react';
import styled from 'styled-components';
import { media } from 'styles/Mixins';
import LogoSVG from 'AssetsRoot/images/homie_v3/homie_logo.svg.react';
import { IconsFooter } from 'utils/ExportCommon';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { FlexColumn, FlexRow } from 'styles/Layout';

const Footer = styled(FlexColumn)`
  display: ${props => (props.showNav ? 'flex' : 'none')};
  padding: 20px 36px;
  background-color: #f0eee8;
  ${media.md`
    padding: 26px 20px;
  `}
`;

const FooterContainer = styled(FlexRow)`
  justify-content: center;
  align-items: center;
  padding-top: 24px;
  ${media.md`
    padding-top: 0;
    border-top: none;
    justify-content: flex-start;
    align-items: flex-start;
  `}
`;

const MobileDataContainer = styled(FlexColumn)`
  display: flex;
  & a {
    color: #000;
  }
  ${media.md`
    display: none;
  `}
`;

const SocialNetworkContainer = styled(FlexColumn)`
  width: 110px;
`;

const LogoContainer = styled(FlexColumn)`
  margin-right: 20px;
  margin-top: 0;
  ${media.md`
    margin-top: 11px;
    margin-right: 20px;
  `}
`;

const Logo = styled(LogoSVG)`
  height: 35px;
  width: 35px;
  ${media.md`
    margin-right: 0;
  `}
`;

const Item = styled.div`
  margin-right: 0;
  margin-bottom: 15px;
  color: #000;
  cursor: pointer;
  ${media.md`
    margin-bottom: 0;
    margin-right: ${({ marginRight = 'normal' }) => marginRight};
  `}
  &:hover {
    text-decoration: underline;
  }
`;

const SocialItem = styled(Item)`
  margin-right: 10px;
`;

const ItemText = styled.p`
  margin-right: ${({ marginRight = 'normal' }) => marginRight};
  color: #000;
  margin: 0px;
  cursor: default;
`;

const Bold = styled.strong`
  margin-bottom: 6px;
  margin-top: ${props => (props.marginTop ? props.marginTop : '0')};
`;

const FooterSection = styled.div`
  display: none;
  color: #000;
  ${media.md`
    flex-basis: 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  `}
`;

const MobileLinksSection = styled(FlexRow)`
  width: 100%;
  max-width: 310px;
  flex-wrap: wrap;
  margin: 0 auto;
  margin-bottom: 10px;
  justify-content: space-between;
  ${media.md`
    display: none;
  `}
`;

const LinksSection = styled(FlexColumn)`
  margin-right: 64px;
`;

function FooterView(props: any): React.Element<any> {
  const openPage = (url: string = '') => {
    window.open(url, '_blank');
  };

  const goToLegal = (section: string = '') => {
    props.history.push(`/legal/${section}`);
  };

  const goToLegalPrivacy = () => {
    goToLegal('aviso-de-privacidad');
  };

  const goToLegalTAC = () => {
    goToLegal('terminos-y-condiciones-generales-homie');
  };

  const goToFacebook = () => {
    openPage('https://www.facebook.com/HomieMexico/');
  };

  const goToTwitter = () => {
    openPage('https://twitter.com/HomieMx_');
  };

  const goToLinkedIn = () => {
    openPage('https://www.linkedin.com/company/homie');
  };

  const goToInstagram = () => {
    openPage('https://www.instagram.com/homiemx_/');
  };

  return (
    <Footer showNav={props.showNav}>
      <MobileLinksSection>
        <FlexColumn>
          <Item onClick={() => props.history.push(`/inmuebles`)}>
            Te buscamos depa
          </Item>
          <Item onClick={() => window.open('https://homie.mx/blog')}>Blog</Item>
          <Item onClick={() => window.open('https://careers.homie.mx/')}>
            Únete al equipo
          </Item>
        </FlexColumn>
        <FlexColumn>
          <Item onClick={goToLegalPrivacy}>Aviso de privacidad</Item>
          <Item onClick={goToLegalTAC}>Términos y condiciones</Item>
          <SocialNetworkContainer>
            <FlexRow justifyContent="space-between">
              <SocialItem onClick={goToFacebook}>
                <IconsFooter.IconFacebook />
              </SocialItem>
              <SocialItem onClick={goToTwitter}>
                <IconsFooter.IconTwitter />
              </SocialItem>
              <SocialItem onClick={goToLinkedIn}>
                <IconsFooter.IconLinkedIn />
              </SocialItem>
              <SocialItem onClick={goToInstagram}>
                <IconsFooter.IconInstagram />
              </SocialItem>
            </FlexRow>
          </SocialNetworkContainer>
        </FlexColumn>
      </MobileLinksSection>
      <FooterContainer>
        <LogoContainer alignItems="center">
          <Logo />
        </LogoContainer>
        <MobileDataContainer>
          <a
            href="https://ayuda.homie.mx/es/knowledge/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Item>Centro de ayuda</Item>
          </a>
          <ItemText>ayuda@homie.mx</ItemText>
          <ItemText>+52 55 6943 7235</ItemText>
          <a
            href="https://www.facebook.com/HomieMexico/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconsFooter.IconFbMessenger /> Escríbenos en facebook
          </a>
        </MobileDataContainer>
        <FooterSection justifyContent="space-evenly" widthSection="60%">
          <FlexRow>
            <LinksSection>
              <Bold>Contacto:</Bold>
              <a
                href="https://ayuda.homie.mx/es/knowledge/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Item>Centro de ayuda</Item>
              </a>
              <ItemText>ayuda@homie.mx</ItemText>
              <ItemText>+52 55 6943 7235</ItemText>
              <a
                href="https://www.facebook.com/HomieMexico/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Item>
                  <IconsFooter.IconFbMessenger /> Escríbenos en facebook
                </Item>
              </a>
            </LinksSection>
            <LinksSection justifyContent="flex-start">
              <Bold>Homie:</Bold>
              <Link to={`/inmuebles`}>
                <Item>Te buscamos depa</Item>
              </Link>
              <a href="https://homie.mx/blog">
                <Item>Blog</Item>
              </a>
              <a href="https://careers.homie.mx/">
                <Item>Únete al equipo</Item>
              </a>
            </LinksSection>
            <LinksSection>
              <Bold>Legales:</Bold>
              <Item onClick={goToLegalPrivacy}>Aviso de privacidad</Item>
              <Item onClick={goToLegalTAC}>Términos y Condiciones</Item>
            </LinksSection>
            <SocialNetworkContainer>
              <Bold>Síguenos:</Bold>
              <FlexRow justifyContent="space-between">
                <SocialItem onClick={goToFacebook}>
                  <IconsFooter.IconFacebook />
                </SocialItem>
                <SocialItem onClick={goToTwitter}>
                  <IconsFooter.IconTwitter />
                </SocialItem>
                <SocialItem onClick={goToLinkedIn}>
                  <IconsFooter.IconLinkedIn />
                </SocialItem>
                <SocialItem onClick={goToInstagram}>
                  <IconsFooter.IconInstagram />
                </SocialItem>
              </FlexRow>
            </SocialNetworkContainer>
          </FlexRow>
        </FooterSection>
      </FooterContainer>
    </Footer>
  );
}

export default withRouter(FooterView);
